
document.addEventListener("DOMContentLoaded", function() {
  // Detecta iPhone / iOS Safari
  const isIOS = /iPhone|iPod|iPad/i.test(navigator.userAgent);

  if (isIOS) {
    // Crea un bloque de estilo exclusivo
    const iosStyle = document.createElement('style');
    iosStyle.innerHTML = `
      /* Estilos solo para iPhone/iPad */
      .novedades-wrapper-top {
        position: relative !important;
        z-index: 1000 !important;
      }
      .text-info {
        position: relative !important;
        z-index: 10 !important;
        padding: 7px 0px 0px 0px !important;
        color: #ff3aff !important;
        background: #fffcba;
      }
      .novedades-content span {
        font-size: 13px !important;
        font-family: "Font-1751878518053" !important;
      }
            header.header.header--middle-center.header--mobile-center.page-width.header--has-menu.header--has-account {
        z-index: 99999999 !important;
    }
    `;
    document.head.appendChild(iosStyle);
  }
});

